/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export function quickHash(value: string) {
  /* eslint-disable fp/no-let */
  let hash = 0;

  /* eslint-disable fp/no-loops */
  /* eslint-disable fp/no-mutation  */
  for (let i = 0; i < value.length; i++) {
    // Equivalent to hash = 31 * hash + str.charCodeAt(i);
    hash = Math.imul(31, hash) + value.charCodeAt(i);
    hash |= 0;
  }

  return (hash >>> 0).toString(36);
}
